<template>
  <div>
    <router-link v-if="href" :to="href">
      {{ text }}
    </router-link>
    <template v-else>{{ text }}</template>
  </div>
</template>

<script>
export default {
  name: 'CharacteristicLink',
  props: {
    href: {
      type: String,
      default: () => '',
    },
    text: {
      type: String,
      default: () => '',
    },
  },
}
</script>

<style></style>
